const ITEMS = ["BE YOUR OWN IB!!", "REBATE USD 15 PER LOT", "TRADE ONCE, DOUBLE THE PROFITS", "KHUSUS AKUN BOOSTER"];

export default function Marquee() {
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-6 text-sm font-black tracking-[0.18em] text-cream md:text-base">
            {t}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-cream/60" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="marquee-strip" className="relative overflow-hidden border-y border-black/10 bg-emerald py-3.5">
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
